'use client';

import { useRouter } from 'next/navigation';
import { ReactNode, useEffect } from 'react';
import { Box, Container, Grid, Group } from '@mantine/core';
import { useUserStore } from '@/shared/stores/userStore';
import LeftMenu from '@/app/cabinet/components/LeftMenu';
import Loading from '@/app/components/loading/Loading';

export function Cabinet({ children }: { children: ReactNode }) {
  const { user, isInitialized } = useUserStore((state) => state);
  const { push } = useRouter();

  useEffect(
    () => {
      if (!user && isInitialized) {
        push('/');
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user, isInitialized],
  );

  return (
    <Container size='xl' mt={100} mb={50}>
      {!(user && isInitialized) ? (
        <Loading size='lg' />
      ) : (
        <Grid>
          <Grid.Col span={{ base: 0, lg: 3 }}>
            <Group visibleFrom='lg'>
              <LeftMenu />
            </Group>
          </Grid.Col>

          <Grid.Col span={{ base: 12, lg: 9 }}>
            <Box>{children}</Box>
          </Grid.Col>
        </Grid>
      )}
    </Container>
  );
}

export default Cabinet;
